var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areaSearch"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.words.label))]),_c('navi-serchnavi-area-links',[_c('img',{staticClass:"map",attrs:{"src":require("@/assets/assets/imgs/map02.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }